import type { TextCardProps } from "@op/puck-types";
import { Dc_Card_IconText } from "@op/sf-op";

const TextCard = ({ icon, children, headline }: TextCardProps) => {
  return (
    <Dc_Card_IconText headline={headline} icon={icon}>
      {children}
    </Dc_Card_IconText>
  );
};

export default TextCard;
